import React, { Fragment, useEffect, useState } from "react";
import { Button, Modal, Popover, Table, Tag, Tooltip } from "antd";
import { Badge } from "antd";
import { EyeOutlined, DeleteOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { Link, useNavigate } from "react-router-dom";
import axios from "../../axios/axios";
import { toast } from "react-toastify";
import { clearLocalStorageExceptOne } from "../../common/Utilities";
import CountdownTimer from "./CountdownTimer";
import UploadedDocuments from "../../components/UploadedDocuments/Uploaded Documents";
import generateImage from '../../images/Generate_Invoice.png';
import paymentImage from '../../images/Payment_details.png';
import invoiceImage from '../../images/Invoice_details.png';

const LoanTabDatas = (props) => {
    const { data, type, pagePermission, onPageChange, pagination } = props;
    const prodData = props.data;
    const navigate = useNavigate();
    const [listDetails, setListDetails] = useState([]);
    const [columnType, setColumnType] = useState();
    const moment = require("moment");
    const [delModal, setDelModal] = useState(false);
    const [delId, setDelid] = useState(null);
    const [popupOpen, setPopupOpen] = useState(false);
    const [selectedRecord, setSelectedRecord] = useState(null);
    const [locked, setLocked] = useState([]);

    const sortedDataSource = [...listDetails];
    const customLocale = {
        emptyText: type == "disbursement" ? "No Disbursement Made" : "No Data",
    };

    const handleConfirm = async (id, e) => {
        e.stopPropagation();
        // ---- immediate JS-level lock ----
        if (handleConfirm.locked?.[id]) return;
        handleConfirm.locked = handleConfirm.locked || {};
        handleConfirm.locked[id] = true;
        setLocked(prev => [...prev, id]);
        try {
            console.log("Clicked once for:", id);
            await axios.post(
                `update/loan/application/invoice-status/${id}`,
                { invoice_status_code: 'SENT' }
            );
            toast.success('Process Completed!');
            setTimeout(() => window.location.reload(), 2000);
        } catch (error) {
            toast.error('Something went wrong!');
            console.error(error);
            handleConfirm.locked[id] = false;
            setLocked(prev => prev.filter(x => x !== id));
        }
    };

    const setLocalApplData = (data) => {
        const [respData] = data;
    };

    const AddLabelToFile = (arr, value) => {
        const files = (Array.isArray(arr) ? arr : arr ? [arr] : [])
            .map(file => {
                if (typeof file === "string") {
                    try {
                        return JSON.parse(file);
                    } catch (e) {
                        console.warn("Failed to parse file string:", file);
                        return { name: file };
                    }
                }
                return file;
            })
            .flat();
        return {
            label: value,
            files
        };
    };

    const columns = [
        {
            title: "Application ID",
            dataIndex: "id",
            fixed: window.innerWidth < 767 ? " " : "left",
            width: 100,
            sorter: false,
            render: (text, record) => {
                if (text) {
                    return {
                        children: (
                            <>
                                <p className="whitespace-nowrap truncate">
                                    OAP-{record.unique_id.toString().padStart(6, "0")}
                                </p>
                                {record?.applicant_name && (
                                    <p className="font-[700]">{record?.applicant_name}</p>
                                )}
                                <p>Guarantor(s): {record?.guarantor_count}</p>
                            </>
                        ),
                    };
                }
            },
        },
        {
            title: "Loan Type",
            dataIndex: "loan_type",
            sorter: false,
            width: 100,
            render: (_, { loan_type }) => (
                <>
                    {loan_type != undefined &&
                        loan_type.map((tag) => {
                            return (
                                <Tag
                                    className="mb-2 last:mb-0 text-center py-[3px]"
                                    style={{ width: "80px" }}
                                    color={"#DDEAFF"}
                                    key={tag}
                                >
                                    <span className="font-[600]" style={{ color: "#0560FB" }}>
                                        {tag.toUpperCase()}
                                    </span>
                                </Tag>
                            );
                        })}
                </>
            ),
        },
        {
            title: "Veh/Chassis No",
            dataIndex: "veh_chassis_no",
            sorter: false,
            width: 130,
            render: (text, record) => {
                return {
                    children: (
                        <div>
                            <p
                                onClick={() => {
                                    localStorage.setItem("applicationId", record.id);
                                    navigate("/case-detail", {
                                        state: { Id: record.id, pagePermission: pagePermission },
                                    });
                                }}
                                className="text-[#0560FB] text-[13px] font-[700] cursor-pointer"
                            >
                                {record.vehicle_reg_no}
                            </p>
                            <p>{text}</p>
                        </div>
                    ),
                };
            },
        },
        {
            title: "Make/Model",
            dataIndex: "veh_make_model",
            sorter: false,
            width: 100,
            render: (text, record) => {
                return {
                    children: (
                        <div>
                            {record?.type_name && (
                                <p className="font-[700]">{record?.type_name}</p>
                            )}
                            <p>{text}</p>
                        </div>
                    ),
                };
            },
        },
        {
            title: "Loan Amt",
            dataIndex: "loan_amt",
            sorter: false,
            width: 90,
            render: (text, record) => {
                const displayValue =
                    record.counter_loan_amt !== undefined &&
                        record.counter_loan_amt !== null &&
                        record.counter_loan_amt !== ""
                        ? record.counter_loan_amt
                        : text;

                if (!record.isCategoryRow) {
                    return {
                        children: (
                            <p>${parseInt(displayValue).toFixed(0)}</p>
                        ),
                    };
                } else {
                    return {
                        children: (
                            <div className="category-row-container h-[25px]">{displayValue}</div>
                        ),
                    };
                }
            },
        },
        {
            title: "Application Status",
            dataIndex: "approved",
            sorter: false,
            width: 155,
            render: (text, record) => {
                if (!record.isCategoryRow) {
                    return (
                        <div className="text-center min-w-[167px] inline-block py-[6px] font-[600] text-[13px] bg-[#FFECEC] text-[#F80707] rounded-[4px]">
                            Pending Documents
                        </div>
                    );
                }
            },
        },
        {
            title: "Created at",
            dataIndex: "created_at",
            sorter: false,
            width: 100,
            render: (text, record) => {
                return (
                    <Fragment>
                        <div className="text-[#1B252F] text-[13px]">
                            {record.created_at}
                        </div>
                    </Fragment>
                );
            },
        },
        {
            title: "Case Exp",
            dataIndex: "expiry",
            sorter: false,
            width: 100,
            render: (text, record) => {
                return (
                    <Fragment>
                        <div className="text-[#1B252F] text-[13px]">
                            {record.expiryDateTime}
                        </div>
                    </Fragment>
                );
            },
        },
        {
            title: "Action",
            dataIndex: "action",
            width: 90,
            render: (text, record) => {
                const LoanStateData = {
                    category: record?.s_category,
                    loanType: record?.s_loanType,
                    loanamount: record?.s_loanamount,
                    loanfor: record?.s_loanfor,
                    parfvalue: record?.s_parfvalue,
                    tenure: record?.s_tenure,
                };
                if (!record.isCategoryRow) {
                    return (
                        <div>
                            {(pagePermission?.create_permission == 1 ||
                                pagePermission?.update_permission == 1) && (
                                    <Link
                                        to={`/loan-apply/${record.id}`}
                                        state={LoanStateData}
                                        className="mb-2 text-[#203B50] text-[14px] flex flex-wrap cursor-pointer border-none shadow-none"
                                        onClick={() => {
                                            clearLocalStorageExceptOne("dealerModuleToken");
                                        }}
                                    >
                                        <EyeOutlined className="mt-1" />
                                        <span>&nbsp;Resume</span>
                                    </Link>
                                )}
                            {pagePermission?.delete_permission == 1 && (
                                <span
                                    className="mb-2 text-[#F80707] text-[14px] flex flex-wrap cursor-pointer border-none shadow-none"
                                    onClick={() => {
                                        setDelModal(true);
                                        setDelid(record.id);
                                    }}
                                >
                                    <DeleteOutlined className="mt-1" />
                                    <span>&nbsp;Delete</span>
                                </span>
                            )}
                        </div>
                    );
                }
            },
        },
    ];
    const pendigColumns = [
        {
            title: "Application ID",
            dataIndex: "id",
            fixed: window.innerWidth < 767 ? " " : "left",
            width: 100,
            sorter: false,
            render: (text, record) => {
                if (text) {
                    return {
                        children: (
                            <>
                                <p className="whitespace-nowrap truncate">
                                    OAP-{record.unique_id.toString().padStart(6, "0")}
                                </p>
                                {record?.applicant_name && (
                                    <p className="font-[700]">{record?.applicant_name}</p>
                                )}
                                <p>Guarantor(s): {record?.guarantor_count}</p>
                            </>
                        ),
                    };
                }
            },
        },
        {
            title: "Loan Type",
            dataIndex: "loan_type",
            sorter: false,
            width: 100,
            render: (_, { loan_type }) => (
                <>
                    {loan_type != undefined &&
                        loan_type.map((tag) => {
                            return (
                                <Tag
                                    className="mb-2 last:mb-0 text-center py-[3px]"
                                    style={{ width: "80px" }}
                                    color={"#DDEAFF"}
                                    key={tag}
                                >
                                    <span className="font-[600]" style={{ color: "#0560FB" }}>
                                        {tag.toUpperCase()}
                                    </span>
                                </Tag>
                            );
                        })}
                </>
            ),
        },
        {
            title: "Veh/Chassis No",
            dataIndex: "veh_chassis_no",
            sorter: false,
            width: 130,
            render: (text, record) => {
                return {
                    children: (
                        <div>
                            <p
                                onClick={() => {
                                    localStorage.setItem("applicationId", record.id);
                                    navigate("/case-detail", {
                                        state: { Id: record.id, pagePermission: pagePermission },
                                    });
                                }}
                                className="text-[#0560FB] text-[13px] font-[700] cursor-pointer"
                            >
                                {record.vehicle_reg_no}
                            </p>
                            <p>{text}</p>
                        </div>
                    ),
                };
            },
        },
        {
            title: "Make/Model",
            dataIndex: "veh_make_model",
            sorter: false,
            width: 100,
            render: (text, record) => {
                return {
                    children: (
                        <div>
                            {record?.type_name && (
                                <p className="font-[700]">{record?.type_name}</p>
                            )}
                            <p>{text}</p>
                        </div>
                    ),
                };
            },
        },
        {
            title: "Loan Amt",
            dataIndex: "loan_amt",
            sorter: false,
            width: 90,
            render: (text, record) => {
                const displayValue =
                    record.counter_loan_amt !== undefined &&
                        record.counter_loan_amt !== null &&
                        record.counter_loan_amt !== ""
                        ? record.counter_loan_amt
                        : text;

                if (!record.isCategoryRow) {
                    return {
                        children: (
                            <p>${parseInt(displayValue).toFixed(0)}</p>
                        ),
                    };
                } else {
                    return {
                        children: (
                            <div className="category-row-container h-[25px]">{displayValue}</div>
                        ),
                    };
                }
            },
        },
        {
            title: "Application Status",
            dataIndex: "approved",
            sorter: false,
            width: 155,
            render: (text, record) => {
                if (!record.isCategoryRow) {
                    return (
                        <div className="text-start">
                            <Popover content={"Approved"}>
                                <Badge
                                    className="mr-2 badge cursor-pointer"
                                    title=" "
                                    showZero={true}
                                    color="#00AE11"
                                    style={{ width: "30px" }}
                                    count={record.approved}
                                    onClick={() => {
                                        clearLocalStorageExceptOne("dealerModuleToken");
                                        localStorage.setItem("applicationId", record.id);
                                        localStorage.removeItem("tabValue");
                                        navigate("/case-detail", {
                                            state: {
                                                Id: record.id,
                                                tabId: "2",
                                                pagePermission: pagePermission,
                                            },
                                        });
                                        setLocalApplData(data);
                                    }}
                                />
                            </Popover>
                            <Popover content={"Counter Offer"}>
                                <Badge
                                    className="mr-2 cursor-pointer"
                                    title=" "
                                    showZero
                                    color="#f48037"
                                    style={{ width: "30px" }}
                                    count={record.counter}
                                    onClick={() => {
                                        clearLocalStorageExceptOne("dealerModuleToken");
                                        localStorage.setItem("applicationId", record.id);
                                        localStorage.removeItem("tabValue");
                                        navigate("/case-detail", {
                                            state: {
                                                Id: record.id,
                                                tabId: "3",
                                                pagePermission: pagePermission,
                                            },
                                        });
                                        setLocalApplData(data);
                                    }}
                                />
                            </Popover>
                            <Popover content={"Rejected"}>
                                <Badge
                                    className="mr-2 cursor-pointer"
                                    title=" "
                                    showZero
                                    color="#D30000"
                                    style={{ width: "30px" }}
                                    count={record.rejected}
                                    onClick={() => {
                                        clearLocalStorageExceptOne("dealerModuleToken");
                                        localStorage.setItem("applicationId", record.id);
                                        localStorage.removeItem("tabValue");
                                        navigate("/case-detail", {
                                            state: {
                                                Id: record.id,
                                                tabId: "4",
                                                pagePermission: pagePermission,
                                            },
                                        });
                                        setLocalApplData(data);
                                    }}
                                />
                            </Popover>
                            <Popover content={"Pending"}>
                                <Badge
                                    className="mr-2 cursor-pointer"
                                    title=" "
                                    showZero
                                    color="#D4D4D4"
                                    style={{ width: "30px" }}
                                    count={record.pending}
                                    onClick={() => {
                                        clearLocalStorageExceptOne("dealerModuleToken");
                                        localStorage.setItem("applicationId", record.id);
                                        localStorage.removeItem("tabValue");
                                        navigate("/case-detail", {
                                            state: {
                                                Id: record.id,
                                                tabId: "1",
                                                pagePermission: pagePermission,
                                            },
                                        });
                                        setLocalApplData(data);
                                    }}
                                />
                            </Popover>
                        </div>
                    );
                }
            },
        },
        {
            title: "Created at",
            dataIndex: "created_at",
            sorter: false,
            width: 100,
            render: (text, record) => {
                return (
                    <Fragment>
                        <div className="text-[#1B252F] text-[13px]">
                            {record.created_at}
                        </div>
                    </Fragment>
                );
            },
        },
        {
            title: "Case Exp",
            dataIndex: "expiry",
            sorter: false,
            width: 100,
            render: (text, record) => {
                return (
                    <Fragment>
                        <div className="text-[#1B252F] text-[13px]">
                            {record.expiryDateTime}
                        </div>
                    </Fragment>
                );
            },
        },
        {
            title: "Action",
            dataIndex: "action",
            width: 90,
            render: (text, record) => {
                const LoanStateData = {
                    category: record?.s_category,
                    loanType: record?.s_loanType,
                    loanamount: record?.s_loanamount,
                    loanfor: record?.s_loanfor,
                    parfvalue: record?.s_parfvalue,
                    tenure: record?.s_tenure,
                };
                if (!record.isCategoryRow) {
                    return (
                        <div>
                            {pagePermission?.view_permission == 1 && (
                                <span
                                    className="mb-2 text-[#203B50] text-[14px] flex flex-wrap cursor-pointer border-none shadow-none"
                                    onClick={() => {
                                        clearLocalStorageExceptOne("dealerModuleToken");
                                        localStorage.setItem("applicationId", record.id);
                                        localStorage.removeItem("tabValue");
                                        navigate("/case-detail", {
                                            state: { Id: record.id, pagePermission: pagePermission },
                                        });
                                        setLocalApplData(data);
                                    }}
                                >
                                    <EyeOutlined className="mt-1" />
                                    <span>&nbsp;View</span>
                                </span>
                            )}
                            {pagePermission?.delete_permission == 1 && (
                                <span
                                    className="mb-2 text-[#F80707] text-[14px] flex flex-wrap cursor-pointer border-none shadow-none"
                                    onClick={() => {
                                        setDelModal(true);
                                        setDelid(record.id);
                                    }}
                                >
                                    <DeleteOutlined className="mt-1" />
                                    <span>&nbsp;Delete</span>
                                </span>
                            )}
                        </div>
                    );
                }
            },
        },
    ];
    const disbursementcolumns = [
        {
            title: "Application ID",
            dataIndex: "id",
            fixed: window.innerWidth < 767 ? " " : "left",
            width: 100,
            sorter: false,
            render: (text, record) => {
                if (text) {
                    return {
                        children: (
                            <>
                                <p className="whitespace-nowrap truncate">
                                    OAP-{record.unique_id.toString().padStart(6, "0")}
                                </p>
                                {record?.applicant_name && (
                                    <p className="font-[700]">{record?.applicant_name}</p>
                                )}
                                <p> {record?.product}</p>
                            </>
                        ),
                    };
                }
            },
        },
        {
            title: "Loan Type",
            dataIndex: "loan_type",
            sorter: false,
            width: 100,
            render: (_, { loan_type }) => (
                <>
                    {loan_type != undefined &&
                        loan_type.map((tag) => {
                            return (
                                <Tag
                                    className="mb-2 last:mb-0 text-center py-[3px]"
                                    style={{ width: "80px" }}
                                    color={"#DDEAFF"}
                                    key={tag}
                                >
                                    <span className="font-[600]" style={{ color: "#0560FB" }}>
                                        {tag.toUpperCase()}
                                    </span>
                                </Tag>
                            );
                        })}
                </>
            ),
        },
        {
            title: "Agent",
            dataIndex: "agent",
            sorter: false,
            width: 100,
            render: (text, record) => {
                return (
                    <Fragment>
                        <div className="text-[#1B252F] text-[13px]">{record.agent}</div>
                    </Fragment>
                );
            },
        },
        {
            title: "Veh/Chassis No",
            dataIndex: "veh_chassis_no",
            sorter: false,
            width: 130,
            render: (text, record) => {
                return {
                    children: (
                        <div>
                            <p
                                onClick={() => {
                                    localStorage.setItem("applicationId", record.id);
                                    navigate("/case-detail", {
                                        state: { Id: record.id, pagePermission: pagePermission },
                                    });
                                }}
                                className="text-[#0560FB] text-[13px] font-[700] cursor-pointer"
                            >
                                {record.vehicle_reg_no}
                            </p>
                            <p>{text}</p>
                        </div>
                    ),
                };
            },
        },
        {
            title: "Make/Model",
            dataIndex: "veh_make_model",
            sorter: false,
            width: 100,
            render: (text, record) => {
                return {
                    children: (
                        <div>
                            {record?.type_name && (
                                <p className="font-[700]">{record?.type_name}</p>
                            )}
                            <p>{text}</p>
                        </div>
                    ),
                };
            },
        },
        {
            title: "Loan Amt",
            dataIndex: "loan_amt",
            sorter: false,
            width: 90,
            render: (text, record) => {
                const displayValue =
                    record.counter_loan_amt !== undefined &&
                        record.counter_loan_amt !== null &&
                        record.counter_loan_amt !== ""
                        ? record.counter_loan_amt
                        : text;

                if (!record.isCategoryRow) {
                    return {
                        children: (
                            <p>${parseInt(displayValue).toFixed(0)}</p>
                        ),
                    };
                } else {
                    return {
                        children: (
                            <div className="category-row-container h-[25px]">{displayValue}</div>
                        ),
                    };
                }
            },
        },
        {
            title: "Dealer Commision",
            dataIndex: "commision_percentage",
            sorter: false,
            width: 100,
            render: (text, record) => {
                return (
                    <Fragment>
                        <div className="text-[#1B252F] text-[13px]">
                            {record.commision_percentage}% (${record.commision_amount})
                        </div>
                    </Fragment>
                );
            },
        },
        {
            title: "Disbursement Date",
            dataIndex: "expiry",
            sorter: false,
            width: 100,
            render: (text, record) => {
                return (
                    <Fragment>
                        <div className="text-[#1B252F] text-[13px]">{record.disb_date}</div>
                    </Fragment>
                );
            },
        },
        {
            title: "Action",
            dataIndex: "action",
            width: 90,
            render: (text, record) => {
                const LoanStateData = {
                    category: record?.s_category,
                    loanType: record?.s_loanType,
                    loanamount: record?.s_loanamount,
                    loanfor: record?.s_loanfor,
                    parfvalue: record?.s_parfvalue,
                    tenure: record?.s_tenure,
                };
                if (!record.isCategoryRow) {
                    const disbDate = record?.disb_date;
                    return (
                        <div>
                            {pagePermission?.view_permission == 1 && (
                                <span
                                    className="mb-2 text-[#203B50] text-[14px] flex flex-wrap cursor-pointer border-none shadow-none"
                                    onClick={() => {
                                        clearLocalStorageExceptOne("dealerModuleToken");
                                        localStorage.setItem("applicationId", record.id);
                                        localStorage.removeItem("tabValue");
                                        navigate("/case-detail", {
                                            state: { Id: record.id, pagePermission: pagePermission },
                                        });
                                        setLocalApplData(data);
                                    }}
                                >
                                    <EyeOutlined className="mt-1" />
                                    <span>&nbsp;View</span>
                                </span>
                            )}
                            {pagePermission?.delete_permission == 1 && (
                                <span
                                    className={`mb-2 text-[#F80707] text-[14px] flex flex-wrap cursor-pointer border-none shadow-none ${disbDate && "pointer-events-none opacity-[0.5]"
                                        }`}
                                    onClick={() => {
                                        setDelModal(true);
                                        setDelid(record.id);
                                    }}
                                >
                                    <DeleteOutlined className="mt-1" />
                                    <span>&nbsp;Delete</span>
                                </span>
                            )}
                        </div>
                    );
                }
            },
        },
    ];
    const expiredColumns = [
        {
            title: "Application ID",
            dataIndex: "id",
            fixed: window.innerWidth < 767 ? " " : "left",
            width: 100,
            sorter: false,
            render: (text, record) => {
                if (text) {
                    return {
                        children: (
                            <>
                                <p className="whitespace-nowrap truncate">
                                    OAP-{record.unique_id.toString().padStart(6, "0")}
                                </p>
                                {record?.applicant_name && (
                                    <p className="font-[700]">{record?.applicant_name}</p>
                                )}
                                <p>Guarantor(s): {record?.guarantor_count}</p>
                            </>
                        ),
                    };
                }
            },
        },
        {
            title: "Loan Type",
            dataIndex: "loan_type",
            sorter: false,
            width: 100,
            render: (_, { loan_type }) => (
                <>
                    {loan_type != undefined &&
                        loan_type.map((tag) => {
                            return (
                                <Tag
                                    className="mb-2 last:mb-0 text-center py-[3px]"
                                    style={{ width: "80px" }}
                                    color={"#DDEAFF"}
                                    key={tag}
                                >
                                    <span className="font-[600]" style={{ color: "#0560FB" }}>
                                        {tag.toUpperCase()}
                                    </span>
                                </Tag>
                            );
                        })}
                </>
            ),
        },
        {
            title: "Veh/Chassis No",
            dataIndex: "veh_chassis_no",
            sorter: false,
            width: 130,
            render: (text, record) => {
                return {
                    children: (
                        <div>
                            <p
                                onClick={() => {
                                    localStorage.setItem("applicationId", record.id);
                                    navigate("/case-detail", {
                                        state: { Id: record.id, pagePermission: pagePermission },
                                    });
                                }}
                                className="text-[#0560FB] text-[13px] font-[700] cursor-pointer"
                            >
                                {record.vehicle_reg_no}
                            </p>
                            <p>{text}</p>
                        </div>
                    ),
                };
            },
        },
        {
            title: "Make/Model",
            dataIndex: "veh_make_model",
            sorter: false,
            width: 100,
            render: (text, record) => {
                return {
                    children: (
                        <div>
                            {record?.type_name && (
                                <p className="font-[700]">{record?.type_name}</p>
                            )}
                            <p>{text}</p>
                        </div>
                    ),
                };
            },
        },
        {
            title: "Loan Amt",
            dataIndex: "loan_amt",
            sorter: false,
            width: 90,
            render: (text, record) => {
                const displayValue =
                    record.counter_loan_amt !== undefined &&
                        record.counter_loan_amt !== null &&
                        record.counter_loan_amt !== ""
                        ? record.counter_loan_amt
                        : text;

                if (!record.isCategoryRow) {
                    return {
                        children: (
                            <p>${parseInt(displayValue).toFixed(0)}</p>
                        ),
                    };
                } else {
                    return {
                        children: (
                            <div className="category-row-container h-[25px]">{displayValue}</div>
                        ),
                    };
                }
            },
        },
        {
            title: "Application Status",
            dataIndex: "approved",
            sorter: false,
            width: 155,
            render: (text, record) => {
                if (!record.isCategoryRow) {
                    return (
                        <div className="text-start">
                            <Popover content={"Approved"}>
                                <Badge
                                    className="mr-2 badge cursor-pointer"
                                    title=" "
                                    showZero={true}
                                    color="#00AE11"
                                    style={{ width: "30px" }}
                                    count={record.approved}
                                    onClick={() => {
                                        clearLocalStorageExceptOne("dealerModuleToken");
                                        localStorage.setItem("applicationId", record.id);
                                        localStorage.removeItem("tabValue");
                                        navigate("/case-detail", {
                                            state: {
                                                Id: record.id,
                                                tabId: "2",
                                                pagePermission: pagePermission,
                                            },
                                        });
                                        setLocalApplData(data);
                                    }}
                                />
                            </Popover>
                            <Popover content={"Counter Offer"}>
                                <Badge
                                    className="mr-2 cursor-pointer"
                                    title=" "
                                    showZero
                                    color="#f48037"
                                    style={{ width: "30px" }}
                                    count={record.counter}
                                    onClick={() => {
                                        clearLocalStorageExceptOne("dealerModuleToken");
                                        localStorage.setItem("applicationId", record.id);
                                        localStorage.removeItem("tabValue");
                                        navigate("/case-detail", {
                                            state: {
                                                Id: record.id,
                                                tabId: "3",
                                                pagePermission: pagePermission,
                                            },
                                        });
                                        setLocalApplData(data);
                                    }}
                                />
                            </Popover>
                            <Popover content={"Rejected"}>
                                <Badge
                                    className="mr-2 cursor-pointer"
                                    title=" "
                                    showZero
                                    color="#D30000"
                                    style={{ width: "30px" }}
                                    count={record.rejected}
                                    onClick={() => {
                                        clearLocalStorageExceptOne("dealerModuleToken");
                                        localStorage.setItem("applicationId", record.id);
                                        localStorage.removeItem("tabValue");
                                        navigate("/case-detail", {
                                            state: {
                                                Id: record.id,
                                                tabId: "4",
                                                pagePermission: pagePermission,
                                            },
                                        });
                                        setLocalApplData(data);
                                    }}
                                />
                            </Popover>
                            <Popover content={"Pending"}>
                                <Badge
                                    className="mr-2 cursor-pointer"
                                    title=" "
                                    showZero
                                    color="#D4D4D4"
                                    style={{ width: "30px" }}
                                    count={record.pending}
                                    onClick={() => {
                                        clearLocalStorageExceptOne("dealerModuleToken");
                                        localStorage.setItem("applicationId", record.id);
                                        localStorage.removeItem("tabValue");
                                        navigate("/case-detail", {
                                            state: {
                                                Id: record.id,
                                                tabId: "1",
                                                pagePermission: pagePermission,
                                            },
                                        });
                                        setLocalApplData(data);
                                    }}
                                />
                            </Popover>
                        </div>
                    );
                }
            },
        },
        {
            title: "Created at",
            dataIndex: "created_at",
            sorter: false,
            width: 100,
            render: (text, record) => {
                return (
                    <Fragment>
                        <div className="text-[#1B252F] text-[13px]">
                            {record.created_at}
                        </div>
                    </Fragment>
                );
            },
        },
        {
            title: "Case Exp",
            dataIndex: "expiry",
            sorter: false,
            width: 100,
            render: (text, record) => {
                return (
                    <Fragment>
                        <div className="text-[#1B252F] text-[13px]">
                            {record.expiryDateTime}
                        </div>
                    </Fragment>
                );
            },
        },
        {
            title: "Action",
            dataIndex: "action",
            width: 90,
            render: (text, record) => {
                const LoanStateData = {
                    category: record?.s_category,
                    loanType: record?.s_loanType,
                    loanamount: record?.s_loanamount,
                    loanfor: record?.s_loanfor,
                    parfvalue: record?.s_parfvalue,
                    tenure: record?.s_tenure,
                };
                if (!record.isCategoryRow) {
                    return (
                        <div>
                            {pagePermission?.view_permission == 1 && (
                                <span
                                    className="mb-2 text-[#203B50] text-[14px] flex flex-wrap cursor-pointer border-none shadow-none"
                                    onClick={() => {
                                        clearLocalStorageExceptOne("dealerModuleToken");
                                        localStorage.setItem("applicationId", record.id);
                                        localStorage.removeItem("tabValue");
                                        navigate("/case-detail", {
                                            state: { Id: record.id, pagePermission: pagePermission },
                                        });
                                        setLocalApplData(data);
                                    }}
                                >
                                    <EyeOutlined className="mt-1" />
                                    <span>&nbsp;View</span>
                                </span>
                            )}
                            {pagePermission?.delete_permission == 1 && (
                                <span
                                    className="mb-2 text-[#F80707] text-[14px] flex flex-wrap cursor-pointer border-none shadow-none"
                                    onClick={() => {
                                        setDelModal(true);
                                        setDelid(record.id);
                                    }}
                                >
                                    <DeleteOutlined className="mt-1" />
                                    <span>&nbsp;Delete</span>
                                </span>
                            )}
                        </div>
                    );
                }
            },
        },
    ];

    const disbursementCompletedColumns = [
        {
            title: "Application ID",
            dataIndex: "id",
            fixed: window.innerWidth < 767 ? " " : "left",
            width: 100,
            sorter: false,
            render: (text, record) => {
                if (text) {
                    return {
                        children: (
                            <>
                                <p className="whitespace-nowrap truncate">
                                    OAP-{record.unique_id.toString().padStart(6, "0")}
                                </p>
                                {record?.applicant_name && (
                                    <p className="font-[700]">{record?.applicant_name}</p>
                                )}
                                <p> {record?.product}</p>
                            </>
                        ),
                    };
                }
            },
        },
        {
            title: "Loan Type",
            dataIndex: "loan_type",
            sorter: false,
            width: 100,
            render: (_, { loan_type }) => (
                <>
                    {loan_type != undefined &&
                        loan_type.map((tag) => {
                            return (
                                <Tag
                                    className="mb-2 last:mb-0 text-center py-[3px]"
                                    style={{ width: "80px" }}
                                    color={"#DDEAFF"}
                                    key={tag}
                                >
                                    <span className="font-[600]" style={{ color: "#0560FB" }}>
                                        {tag.toUpperCase()}
                                    </span>
                                </Tag>
                            );
                        })}
                </>
            ),
        },
        {
            title: "Agent",
            dataIndex: "agent",
            sorter: false,
            width: 100,
            render: (text, record) => {
                return (
                    <Fragment>
                        <div className="text-[#1B252F] text-[13px]">{record.agent}</div>
                    </Fragment>
                );
            },
        },
        {
            title: "Veh/Chassis No",
            dataIndex: "veh_chassis_no",
            sorter: false,
            width: 130,
            render: (text, record) => {
                return {
                    children: (
                        <div>
                            <p
                                onClick={() => {
                                    localStorage.setItem("applicationId", record.id);
                                    navigate("/case-detail", {
                                        state: { Id: record.id, pagePermission: pagePermission },
                                    });
                                }}
                                className="text-[#0560FB] text-[13px] font-[700] cursor-pointer"
                            >
                                {record.vehicle_reg_no}
                            </p>
                            <p>{text}</p>
                        </div>
                    ),
                };
            },
        },
        {
            title: "Make/Model",
            dataIndex: "veh_make_model",
            sorter: false,
            width: 100,
            render: (text, record) => {
                return {
                    children: (
                        <div>
                            {record?.type_name && (
                                <p className="font-[700]">{record?.type_name}</p>
                            )}
                            <p>{text}</p>
                        </div>
                    ),
                };
            },
        },
        {
            title: "Loan Amt",
            dataIndex: "loan_amt",
            sorter: false,
            width: 90,
            render: (text, record) => {
                const displayValue =
                    record.counter_loan_amt !== undefined &&
                        record.counter_loan_amt !== null &&
                        record.counter_loan_amt !== ""
                        ? record.counter_loan_amt
                        : text;

                if (!record.isCategoryRow) {
                    return {
                        children: (
                            <p>${parseInt(displayValue).toFixed(0)}</p>
                        ),
                    };
                } else {
                    return {
                        children: (
                            <div className="category-row-container h-[25px]">{displayValue}</div>
                        ),
                    };
                }
            },
        },
        {
            title: "Dealer Commision",
            dataIndex: "commision_percentage",
            sorter: false,
            width: 100,
            render: (text, record) => {
                return (
                    <Fragment>
                        <div className="text-[#1B252F] text-[13px]">
                            {record.commision_percentage}% (${record.commision_amount})
                        </div>
                    </Fragment>
                );
            },
        },
        {
            title: "Status",
            dataIndex: "expiry",
            sorter: false,
            width: 100,
            render: (text, record) => {
                return (
                    <Fragment>
                        <div
                            className={`text-[13px] font-medium ${record.invoice_status_code === 0
                                ? 'text-orange-500'
                                : record.invoice_status_code === 1
                                    ? 'text-blue-500'
                                    : record.invoice_status_code === 2
                                        ? 'text-yellow-500'
                                        : record.invoice_status_code === 3
                                            ? 'text-green-500'
                                            : 'text-gray-500'
                                }`}
                        >
                            {record.invoice_status_code === 0
                                ? 'Pending'
                                : record.invoice_status_code === 1
                                    ? 'Send to Agent'
                                    : record.invoice_status_code === 2
                                        ? 'Paynow Received'
                                        : record.invoice_status_code === 3
                                            ? 'Paid'
                                            : 'Unknown'}
                        </div>

                    </Fragment>
                );
            },
        },
        {
            title: "Invoice Payment Date",
            dataIndex: "expiry",
            sorter: false,
            width: 100,
            render: (text, record) => {
                return (
                    <Fragment>
                        <div className="text-[#1B252F] text-[13px]">{record.invoice_start_date}</div>
                    </Fragment>
                );
            },
        },
        {
            title: "Action",
            dataIndex: "action",
            width: 90,
            render: (text, record) => {
                const LoanStateData = {
                    category: record?.s_category,
                    loanType: record?.s_loanType,
                    loanamount: record?.s_loanamount,
                    loanfor: record?.s_loanfor,
                    parfvalue: record?.s_parfvalue,
                    tenure: record?.s_tenure,
                };
                const viewReportData = {
                    invoice_start_date: record.invoice_start_date,
                    invoice_remarks: record.invoice_start_date,
                    invoice_disbursement_doc: record.invoice_disbursement_doc,
                }
                if (!record.isCategoryRow) {
                    return (
                        <div>
                            {record.invoice_status_code !== null && (
                                <div className="flex flex-col items-center space-y-2">
                                    <div className="flex justify-center items-center gap-6">

                                        <Tooltip title="Generate" placement="top">
                                            <div className={`cursor-pointer ${record.invoice_status_code !== 0 ? 'opacity-50' : ''}`}>
                                                <span
                                                    onClick={() => {
                                                        if (record.invoice_status_code === 0) {
                                                            navigate('/generated-invoice', { state: { LoanStateData, record } });
                                                        }
                                                    }}
                                                >
                                                    <img src={generateImage} alt="Invoice" className="w-[28px] h-auto" />
                                                </span>
                                            </div>
                                        </Tooltip>

                                        <Tooltip title="Invoice Details" placement="top">
                                            <div className={`cursor-pointer ${!(record.invoice_status_code === 1 || record.invoice_status_code === 2 || record.invoice_status_code === 3) ? 'opacity-50' : ''}`}>
                                                <span
                                                    onClick={() => {
                                                        if (record.invoice_status_code === 1 || record.invoice_status_code === 2 || record.invoice_status_code === 3) {
                                                            navigate('/generated-invoice', { state: { LoanStateData, record } });
                                                        }
                                                    }}
                                                >
                                                    <img src={invoiceImage} alt="Invoice" className="w-[28px] h-auto" />
                                                </span>
                                            </div>
                                        </Tooltip>

                                        <Tooltip title="Payment Details" placement="top">
                                            <div className={`cursor-pointer ${!(record.invoice_status_code === 2 || record.invoice_status_code === 3) ? 'opacity-50' : ''}`}>
                                                <span
                                                    onClick={(e) => {
                                                        if (record.invoice_status_code === 2 || record.invoice_status_code === 3) {
                                                            e.stopPropagation();
                                                            setSelectedRecord(record);
                                                            setPopupOpen(true);
                                                        }
                                                    }}
                                                >
                                                    <img src={paymentImage} alt="Invoice" className="w-[28px] h-auto" />
                                                </span>
                                            </div>
                                        </Tooltip>
                                    </div>

                                    {record.invoice_status_code === 2 && record?.invoice_auto_confirm && (
                                        <div className="flex items-center gap-2 text-sm text-center">
                                            <CountdownTimer
                                                expiryTime={new Date(record.invoice_auto_confirm.replace(' ', 'T'))}
                                            />
                                            <Tooltip title="Auto-confirm on timer end." placement="top">
                                                <span onClick={() => { }} className="cursor-pointer">
                                                    <InfoCircleOutlined />
                                                </span>
                                            </Tooltip>
                                        </div>
                                    )}

                                    {/* Confirm Button */}
                                    {record.invoice_status_code === 2 && (
                                        <Button
                                            type="dashed"
                                            size="small"
                                            disabled={locked.includes(record.id)}
                                            loading={locked.includes(record.id)}
                                            onClick={(e) => handleConfirm(record.id, e)}
                                        >
                                            Confirm
                                        </Button>
                                    )}
                                </div>
                            )
                            }
                        </div >
                    );
                }
            },
        },
    ];

    useEffect(() => {
        let listData = data;
        let updateListData = [];
        if (listData != undefined && listData.length > 0) {
            listData?.map((list, idx) => {
                let loanTypes = list?.loanTypeLabels;
                let detail = {};
                detail["key"] = idx + 1;
                detail["id"] = list.id;
                detail["loan_type"] = loanTypes;
                detail["created_at"] = moment(list["created_at"]).format(
                    "DD-MM-YYYY HH:mm"
                );
                detail["veh_chassis_no"] = list.vehicle_details?.vehicle_chassis_no;
                detail["vehicle_reg_no"] = list.vehicle_details?.vehicle_reg_no;
                detail["veh_make_model"] = list.vehicle_details?.make_model;
                detail["unique_id"] = list.uniqueId;
                detail["loan_amt"] = list.loanamount;
                detail["counter_loan_amt"] = list?.counter_offer_update?.loanamount;
                detail["customer_selected"] = list.customer_selected;
                detail["approved"] = list.approved;
                detail["pending"] = list.pending;
                detail["rejected"] = list.rejected;
                detail["counter"] = list.counter_offered;
                detail["expiryDateTime"] = moment(list["expired_at"]).format(
                    "DD-MM-YYYY HH:mm"
                );
                detail["type"] = list.typeinfo?.name;
                detail["is_completed"] = list?.is_completed;
                detail["s_category"] = list?.category;
                detail["s_loanType"] = list?.loanType;
                detail["s_loanamount"] = list?.loanamount;
                detail["s_loanfor"] = list?.loanfor ? list?.loanfor : "";
                detail["s_parfvalue"] = list?.parfvalue;
                detail["s_tenure"] = String(list?.tenure);
                detail["guarantor_count"] = list?.guarantor_details.length;
                detail["applicant_name"] = list?.applicant_details?.name
                    ? list?.applicant_details?.name
                    : null;
                detail["type_name"] = list?.typeinfo?.name
                    ? list?.typeinfo?.name
                    : null;
                detail["disb_date"] = list?.disbursementinfo?.disbursement_date
                    ? moment(list?.disbursementinfo?.disbursement_date, "YYYY-MM-DD").format(
                        "DD-MM-YYYY"
                    )
                    : "";
                detail["commision_amount"] = list?.disbursementinfo
                    ? list?.disbursementinfo?.commision_amount
                    : "0";
                detail["agent"] = list?.disbursementinfo?.applicationproductinfo
                    ?.agentcommisioninfo?.agentinfo
                    ? list?.disbursementinfo?.applicationproductinfo?.agentcommisioninfo
                        ?.agentinfo?.name
                    : "--";
                detail["commision_percentage"] = list?.disbursementinfo
                    ? list?.disbursementinfo?.commision_percentage
                    : "0";
                detail["product"] = list?.disbursementinfo?.applicationproductinfo
                    ?.productinfo
                    ? list?.disbursementinfo?.applicationproductinfo?.productinfo?.name
                    : "";
                detail["invoice_status_code"] = list?.invoice_status_code;
                detail["agent_mail_address"] = list?.ownerinfo?.email;
                detail["invoice_auto_confirm"] = list?.expiry_time;
                detail["invoice_start_date"] = list?.invoice_start_date;
                detail["invoice_remarks"] = list?.invoice_remarks;
                detail["invoice_disbursement_doc"] = list?.invoice_disbursement_doc;
                updateListData.push(detail);
            });
            if (type == "incomplete") {
                updateListData = updateListData.filter(
                    (item) => item.is_completed === 0
                );
            }
            if (type == "pending") {
                updateListData = updateListData.filter(
                    (item) => item.is_completed === 1
                );
            }

            setListDetails(updateListData);
        }
    }, [data, type]);

    useEffect(() => {
        if (type == "expired") {
            setColumnType(expiredColumns);
        } else if (type == "pending") {
            setColumnType(pendigColumns);
        } else if (type == "incomplete") {
            setColumnType(columns);
        } else if (type == "disbursement") {
            setColumnType(disbursementcolumns);
        } else {
            setColumnType(disbursementCompletedColumns);
        }
    }, [type]);

    return (
        <div className="table-container" style={{ overflowX: "auto" }}>
            {/* View Report */}
            <Modal
                open={popupOpen}
                onCancel={() => {
                    setPopupOpen(false);
                }}
                centered
                footer={null}
            >
                <div className="reject-popup-block">
                    <h2 className="text-center ">Invoice Report</h2>
                    <div className="flex flex-col">
                        <div className="mb-6 text-sm font-medium text-gray-700">
                            <strong className="ml-8">Invoice Start Date:</strong><span className="ml-7">{selectedRecord?.invoice_start_date}</span>
                        </div>
                        <div className="mb-1 text-sm font-medium text-gray-700">
                            <strong className="ml-8">Invoice Remarks:</strong><span className="ml-10">{selectedRecord?.invoice_remarks}</span>
                        </div>
                        <div className="mb-6 text-sm font-medium text-gray-700">

                            {/* Uploaded Documents */}
                            <div className="preview-list-block">
                                <div className="download-block">
                                    <strong className="mb-6">Invoice Documents:</strong>
                                </div>
                                <div className="preview-list-group" >
                                    {selectedRecord?.invoice_disbursement_doc?.length > 0 && (
                                        <UploadedDocuments
                                            documents={AddLabelToFile(
                                                selectedRecord?.invoice_disbursement_doc,
                                            )}
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                        {/* invoice_documents */}
                    </div>
                    {/* <div className=" mb-2 mt-0 flex justify-end">
                        <Button
                            type="primary"
                            onClick={() => setPopupOpen(false)}
                        >
                            Close
                        </Button>
                    </div> */}
                </div>
            </Modal>
            <Modal
                title="Delete Application"
                centered
                open={delModal}
                onOk={async () => {
                    const tokenId = localStorage.getItem("dealerModuleToken");
                    const resp = await axios.delete(`/loan/application/delete/${delId}`, {
                        headers: {
                            Authorization: `Bearer ${tokenId}`,
                        },
                    });
                    if (resp) {
                        props.fetchLoanCase("delete");
                        toast.success("Deleted Successfully!!!", { autoClose: 2500 });
                        setDelModal(false);
                    }
                }}
                onCancel={() => setDelModal(false)}
                wrapClassName="delApplModal"
                okText={
                    <>
                        <DeleteOutlined />
                        &nbsp;Delete
                    </>
                }
            >
                <p>Are you sure want to delete?</p>
            </Modal>
            <Table
                showSorterTooltip={false}
                dataSource={sortedDataSource}
                columns={columnType}
                pagination={{
                    current: pagination?.currentPage,
                    size: pagination.pageSize,
                }}
                scroll={{ x: type != "expired" ? 1300 : 1300 }}
                rowKey={(record, index) => index}
                locale={customLocale}
                className="custom-table"
                current={2}
                onChange={(e) => {
                    onPageChange(e);
                }}
            />
        </div>
    );
};

export default LoanTabDatas;
